import React from "react";
import Banner from "./Banner.jsx";
import About from "./About.jsx";
import Philosophy from "./Philosophy.jsx";
import Services from "./Services.jsx";
import Transformation from "./Transformation.jsx";
import Testimonials from "./Testimonials.jsx";
import WhyChooseUs from "./WhyChooseUs.jsx";
import Blogs from "./Blogs.jsx";
import { LogoProvider } from "../contexts/LogoContext";

const Home = () => {
    return (
        <div className="home-container">
            <LogoProvider>
                <Banner />
                <About />
                <Philosophy />
                <Services />
                <Transformation />
                <Testimonials />
                <WhyChooseUs />
                <Blogs />
            </LogoProvider>
        </div>
    );
};

export default Home;
